import {ethers} from 'ethers'


const createContractCalls = () => {

let node = 'https://eth-goerli.alchemyapi.io/v2/rahrAG37rgq4gQKI6NOgBxNZwXvl5mAE'

const getBalance = async ()=>{
  try {
    let pk = await getPrivateKey()
    const provider = new ethers.providers.JsonRpcProvider(node)
    let walletWithProvider = new ethers.Wallet(pk, provider);
    let balance =ethers.utils.formatEther( await walletWithProvider.getBalance())
    return balance
  } catch (error) {
      console.log(error)
  }
}

const transfer = async (to , amount)=>{
  try {
    let pk = await getPrivateKey()
    const provider = new ethers.providers.JsonRpcProvider(node)
    let walletWithProvider = new ethers.Wallet(pk, provider);
    let balance = ethers.utils.parseEther(amount)
    let tx = {
      to: to,
      value: balance
  };
  const transaction = await walletWithProvider.sendTransaction(tx);
  let _tx = await transaction.wait()
  console.log(_tx)
    return true
  } catch (error) {
      console.log(error)
  }
}

const savePassword = async (pass)=>{
    try {
      //  localStorage.setItem("lastname", "Smith");
      localStorage.setItem('wp' , pass.toString())
    } catch (error) {
        
    }
}

const getPassword = async ()=>{
    try {
      if(localStorage.getItem('wp') != undefined || localStorage.getItem('wp') != null){
        return true
      }else{
        return false
      }
    } catch (error) {
        
    }
}
const wallet_exixt = async () => {
  try {
    if (
      localStorage.getItem("pk") != undefined ||
      localStorage.getItem("pk") != null
    ) {
      return true;
    } else {
      return false;
    }
  } catch (error) {}
};

const generateWallet = async (pass)=>{
    try {
      //localStorage.setItem("lastname", "Smith");
      const wallet = ethers.Wallet.createRandom();
      const recoveryPhrase = wallet._mnemonic().phrase;
      const privatekey = wallet.privateKey;
      const address = wallet.address
      console.log(recoveryPhrase ,privatekey, address)
      localStorage.setItem('sp' , recoveryPhrase.toString())
      localStorage.setItem('pk' , privatekey.toString())
      localStorage.setItem('ad' , address.toString())
    } catch (error) {
        
    }
}

const saveSecretphrase = async (pass)=>{
    try {
      //  localStorage.setItem("lastname", "Smith");
      localStorage.setItem('sp' , pass.toString())
    } catch (error) {
        
    }
}

const getSecretphrase = async ()=>{
    return localStorage.getItem('sp')
}
const getPrivateKey = async ()=>{
    return localStorage.getItem('pk')
}
const getwalletaddress = async ()=>{
    return localStorage.getItem('ad')
}



return {
    savePassword,
    getPassword,
    saveSecretphrase,
    getSecretphrase,
    getPrivateKey,
    getwalletaddress,
    generateWallet,
    getBalance,
    transfer,
    wallet_exixt
}

}
const calls = createContractCalls();


export default calls;